import React, { Component } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/scss/react-flags-select.scss';
import { countries } from './countries';
export default class FlagDropDown extends Component {
  render() {
    return (
      <ReactFlagsSelect
        searchable={true}
        onSelect={this.props.onSelect}
        defaultCountry={this.props.defaultCountry && this.props.defaultCountry !== '' ? this.props.defaultCountry : 'LK'}
        disabled={this.props.disabled}
        // customLabels={countries}
        showSelectedLabel={this.props.isShowFlag}
        searchPlaceholder="Search for a country" />
    );
  }
}